import { render } from "./DepositsSentSuccessful.vue?vue&type=template&id=037546a1&scoped=true"
import script from "./DepositsSentSuccessful.vue?vue&type=script&lang=js"
export * from "./DepositsSentSuccessful.vue?vue&type=script&lang=js"

import "./DepositsSentSuccessful.vue?vue&type=style&index=0&id=037546a1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037546a1"]])

export default __exports__